import { render, staticRenderFns } from "./MajorKeyNotes.vue?vue&type=template&id=25315490"
import script from "./MajorKeyNotes.vue?vue&type=script&lang=js"
export * from "./MajorKeyNotes.vue?vue&type=script&lang=js"
import style0 from "./MajorKeyNotes.vue?vue&type=style&index=0&id=25315490&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports